"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
const lodash_1 = require("lodash");
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const globalErrorMessages_1 = require("../global/model/error/globalErrorMessages");
const uuidError_1 = require("./model/error/uuidError");
class UUID {
    constructor(instance) {
        this.instance = instance;
    }
    getAllUUIDs(token) {
        return new Promise((resolve, reject) => {
            const URL = '/tags';
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const uuids = res.data;
                resolve(uuids);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    getUUIDByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/tags/${id}`;
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const uuid = res.data;
                resolve(uuid);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    getUUIDByAddress(token, address) {
        return new Promise((resolve, reject) => {
            const params = {
                address,
            };
            this._getUUIDsByParams(token, params, false)
                .then((res) => {
                const uuid = res;
                resolve(uuid);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    getUUIDByPublicKey(token, publicKey) {
        return new Promise((resolve, reject) => {
            const params = {
                public_key: publicKey,
            };
            this._getUUIDsByParams(token, params, false)
                .then((res) => {
                const uuid = res;
                resolve(uuid);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    _getUUIDsByParams(token, params, bulk) {
        return new Promise((resolve, reject) => {
            const URL = '/tags';
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: { Authorization: authStr },
                params,
            };
            this.instance.get(URL, config)
                .then((res) => {
                const uuids = res.data;
                if (!uuids || uuids.length === 0) {
                    resolve(null);
                    return;
                }
                if (bulk) {
                    resolve(uuids);
                }
                else {
                    resolve(uuids[0]);
                }
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    createUUID(token, uuidPayload) {
        return new Promise((resolve, reject) => {
            const URL = '/tags';
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const data = uuidPayload;
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: {
                    Authorization: authStr,
                }
            };
            this.instance.post(URL, data, config)
                .then((res) => {
                const uuid = res.data;
                resolve(uuid);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    createUUIDBulk(token, uuidPayloads) {
        return new Promise((resolve, reject) => {
            const URL = '/tags';
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const data = {
                fields: uuidPayloads,
            };
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: {
                    Authorization: authStr,
                }
            };
            this.instance.post(URL, data, config)
                .then((res) => {
                const uuids = res.data;
                resolve(uuids);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    updateUUIDByID(token, uuidPayload) {
        return new Promise((resolve, reject) => {
            const thePayload = lodash_1.clone(uuidPayload);
            const URL = `/tags/${thePayload.id}`;
            delete thePayload.id;
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.put(URL, thePayload, config)
                .then((res) => {
                const uuid = res.data;
                resolve(uuid);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    deleteUUIDByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/tags/${id}`;
            if (!token) {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.delete(URL, config)
                .then((res) => {
                if (res.data.message === 'Successfully deleted') {
                    resolve(true);
                }
                else {
                    reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, 'Delete failed'));
                }
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    verifyUUID(verifyPayload) {
        return new Promise((resolve, reject) => {
            const URL = `/tags/verify`;
            const config = {
                params: verifyPayload,
            };
            this.instance.get(URL, config)
                .then((res) => {
                const verify = res.data;
                resolve(verify);
            })
                .catch((err) => {
                reject(new uuidError_1.UUIDError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
}
exports.UUID = UUID;
//# sourceMappingURL=uuid.js.map